<template>
  <span class="message">{{ message }}</span>
</template>

<script>
import Accumulative from '@/mixins/Accumulative'

export default {
  name: 'ScoreMessage',

  mixins: [Accumulative],

  computed: {
    message () {
      const value = this.totalScore

      return this.question.message.config
        .find(({ min, max }) => value >= (min || 0) && value <= (max || Infinity)).value
    }
  }
}
</script>

<style lang="scss" scoped>
  .message {
    @media (max-width: $screen-md) {
      font-size: 15px;
    }
  }
</style>
